import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { z } from "zod";

export type EmailAddressJSON = z.infer<typeof EmailAddressSchema.EmailAddressJSONZ>;
export type EmailAddressParams = z.infer<typeof EmailAddressSchema.EmailAddressZ>;

export default class EmailAddressSchema {
  public static readonly EmailAddressJSONZ = z.email();
  public static readonly EmailAddressZ = z.email();

  public static readonly codec = z.codec(EmailAddressSchema.EmailAddressJSONZ, EmailAddressSchema.EmailAddressZ, {
    decode: (data) => data,
    encode: (email) => email,
  });

  public static validate(value: unknown, logError: boolean = true): EmailAddressParams {
    return parseOrThrow(EmailAddressSchema.EmailAddressZ, value, {
      logError,
      schemaName: "EmailAddressSchema",
      operation: "Validating EmailAddressParams",
      payloadSample: value,
    });
  }

  public static validateJSON(value: unknown): EmailAddressJSON {
    return parseOrThrow(EmailAddressSchema.EmailAddressJSONZ, value, {
      logError: true,
      schemaName: "EmailAddressSchema",
      operation: "Validating EmailAddressJSON",
      payloadSample: value,
    });
  }

  public static isValid(values: unknown): values is EmailAddressParams {
    try {
      EmailAddressSchema.validate(values, false);
      return true;
    } catch {
      return false;
    }
  }

  public static isValidJSON(values: unknown): values is EmailAddressParams {
    try {
      EmailAddressSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: unknown): EmailAddressParams {
    const parsed = parseOrThrow(EmailAddressSchema.EmailAddressJSONZ, data, {
      logError: true,
      schemaName: "EmailAddressSchema",
      operation: "Deserializing EmailAddressJSON",
      payloadSample: data,
    });
    return EmailAddressSchema.codec.decode(parsed);
  }

  public static serialize(data: unknown): EmailAddressJSON {
    const parsed = EmailAddressSchema.validate(data);
    return EmailAddressSchema.codec.encode(parsed);
  }
}
